// src/providers/AppProviders.tsx
import { ReactNode, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ClerkProvider, useAuth } from '@clerk/clerk-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '../lib/queryClient'
import { ModalProvider } from './ModalProvider'
import SessionInactivityManager from './SessionInactivityProvider'
import { TenantProvider } from './TenantProvider' // <-- add this import

const pk = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY as string

function Splash() {
  return <div style={{ minHeight: '100vh', background: '#fff' }} />
}

function ClerkStableGate({ children }: { children: ReactNode }) {
  const { isLoaded } = useAuth()
  const [ready, setReady] = useState(false)
  useEffect(() => {
    if (isLoaded) setReady(true)
  }, [isLoaded])
  if (!ready) return <Splash />
  return <>{children}</>
}

export function AppProviders({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  return (
    <ClerkProvider
      publishableKey={pk}
      routerPush={(to: string) => navigate(to)}
      routerReplace={(to: string) => navigate(to, { replace: true })}
    >
      <ClerkStableGate>
        <QueryClientProvider client={queryClient}>
          <TenantProvider>
            <ModalProvider>
              {children}
              <SessionInactivityManager />
            </ModalProvider>
          </TenantProvider>

          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ClerkStableGate>
    </ClerkProvider>
  )
}
